export default "__VITE_ASSET__3d9e4356__"